import { render, staticRenderFns } from "./SendMailTemplateNew.vue?vue&type=template&id=031fd1f6&scoped=true&"
import script from "./SendMailTemplateNew.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplateNew.vue?vue&type=script&lang=js&"
import style0 from "./SendMailTemplateNew.vue?vue&type=style&index=0&id=031fd1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fd1f6",
  null
  
)

export default component.exports